import React, { useState } from 'react';
import styled from 'styled-components';

const TopContainer = styled.div`
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  position: relative;
  transition: all 0.3s ease;
`;

const ToggleButton = styled.button`
  width: 100%;
  background: none;
  border: none;
  color: #64748b;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 16px;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(102, 126, 234, 0.05);
    color: #667eea;
  }
  
  svg {
    width: 14px;
    height: 14px;
    transition: transform 0.3s ease;
    transform: ${props => props.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
  }
`;

const TagsContainer = styled.div`
  max-height: ${props => props.isExpanded ? '200px' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  padding: ${props => props.isExpanded ? '12px 16px 16px 16px' : '0 16px'};
`;

const TagsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
`;

const Tag = styled.button`
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  
  &:hover {
    border-color: #667eea;
    color: #667eea;
    background: #f0f4ff;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(102, 126, 234, 0.1);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const WelcomeText = styled.div`
  text-align: center;
  color: #64748b;
  font-size: 11px;
  margin-bottom: 12px;
  font-weight: 500;
`;

const TopQuickActions = ({ isFreshChat, onQuickActionSelect }) => {
  // Default expanded when fresh, collapsed when in conversation
  const [isExpanded, setIsExpanded] = useState(isFreshChat);

  // Update expanded state when chat freshness changes
  React.useEffect(() => {
    setIsExpanded(isFreshChat);
  }, [isFreshChat]);

  // Flatten all options into simple tags
  const allOptions = [
    { id: 'case-status', label: 'Active Case' },
    { id: 'completed-cases', label: 'Completed Cases' },
    { id: 'estimated-time', label: 'Estimated Completion Time' },
    { id: 'callback', label: 'Request Callback' },
    { id: 'doctor', label: 'Talk to Radiologist' },
    { id: 'technical', label: 'Technical Issue' },
    { id: 'finance', label: 'Finance Query' },
    { id: 'feedback', label: 'Feedback' },
    { id: 'refer', label: 'Refer to 5C' },
    // { id: 'aura-features', label: 'Aura Features' }
  ];

  // Use the same message mapping (click sends this message to the bot)
  const messageMap = {
    'case-status': 'I need help with an active case',
    'completed-cases': 'I need help with completed cases',
    'callback': 'I want to request a callback',
    'doctor': 'I want to talk to a radiologist',
    'technical': 'I am facing a technical issue',
    'finance': 'I have a finance query',
    'feedback': 'I want to give feedback',
    'refer': 'I want to refer to 5C',
    'estimated-time': 'Help me with estimated time of completion.'
  };

  const handleTagClick = (optionId) => {
    const message = messageMap[optionId];
    if (message && onQuickActionSelect) {
      // Collapse the panel when user selects an option
      setIsExpanded(false);
      onQuickActionSelect(message);
    }
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <TopContainer>
      <TagsContainer isExpanded={isExpanded}>
        {/* <WelcomeText>
          {isFreshChat ? 'Choose a topic to get started quickly' : 'Need help with something else?'}
        </WelcomeText> */}
        <TagsGrid>
          {allOptions.map((option) => (
            <Tag
              key={option.id}
              onClick={() => handleTagClick(option.id)}
            >
              {option.label}
            </Tag>
          ))}
        </TagsGrid>
      </TagsContainer>
      
      <ToggleButton onClick={toggleExpanded} isExpanded={isExpanded}>
        {isExpanded ? 'Hide' : 'Show'} quick actions
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M19 9l-7 7-7-7" />
        </svg>
      </ToggleButton>
    </TopContainer>
  );
};

export default TopQuickActions; 